var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect0, _rect1, _path2, _rect10, _circle, _path3, _rect11, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnchorBillingEmptyState = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "136 28 225 222",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 496,
  height: 280,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 230,
  y: 69,
  width: 19.1397,
  height: 83.5186,
  fill: "#E3E5E8"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 226.818,
  y: 126,
  width: 24,
  height: 20.9995,
  rx: 1,
  fill: "#E3E5E8"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 192,
  y: 70,
  width: 19.1397,
  height: 83.5186,
  fill: "#E3E5E8"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 189,
  y: 126,
  width: 25,
  height: 21,
  rx: 1,
  fill: "#E3E5E8"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 155,
  y: 69,
  width: 18,
  height: 84,
  fill: "#E3E5E8"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 152,
  y: 126,
  width: 24,
  height: 20.9995,
  rx: 1,
  fill: "#E3E5E8"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 270,
  y: 135,
  width: 19,
  height: 132,
  transform: "rotate(90 270 135)",
  fill: "#E3E5E8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M261.521 59.1716C264.262 60.5152 266 63.3021 266 66.3552L266 70L138 70L138 66.3552C138 63.3021 139.738 60.5152 142.479 59.1716L202 30L261.521 59.1716Z",
  fill: "#E3E5E8"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 275.897,
  y: 69.8789,
  width: 2.31997,
  height: 147.898,
  transform: "rotate(90 275.897 69.8789)",
  fill: "white"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 231.052,
  y: 70.0508,
  width: 126,
  height: 177,
  rx: 7,
  fill: "white"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 250.052,
  y: 204.051,
  width: 88,
  height: 24,
  rx: 4,
  fill: "#F3F0FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M280.163 221.051H281.875V217.034H285.804V215.599H281.875V213.032H286.219V211.596H280.163V221.051ZM290.325 221.189C291.977 221.189 293.113 220.381 293.408 219.149L291.848 218.973C291.622 219.574 291.068 219.887 290.348 219.887C289.267 219.887 288.552 219.176 288.538 217.962H293.478V217.45C293.478 214.962 291.982 213.868 290.237 213.868C288.206 213.868 286.881 215.359 286.881 217.547C286.881 219.772 288.187 221.189 290.325 221.189ZM288.543 216.836C288.593 215.931 289.263 215.169 290.26 215.169C291.22 215.169 291.866 215.871 291.876 216.836H288.543ZM298.031 221.189C299.683 221.189 300.819 220.381 301.114 219.149L299.554 218.973C299.328 219.574 298.774 219.887 298.054 219.887C296.973 219.887 296.258 219.176 296.244 217.962H301.184V217.45C301.184 214.962 299.688 213.868 297.943 213.868C295.912 213.868 294.587 215.359 294.587 217.547C294.587 219.772 295.893 221.189 298.031 221.189ZM296.249 216.836C296.299 215.931 296.969 215.169 297.966 215.169C298.926 215.169 299.572 215.871 299.582 216.836H296.249ZM308.202 215.834C307.971 214.634 307.011 213.868 305.349 213.868C303.641 213.868 302.477 214.708 302.482 216.019C302.477 217.053 303.114 217.736 304.476 218.018L305.686 218.272C306.337 218.415 306.641 218.678 306.641 219.08C306.641 219.564 306.115 219.929 305.321 219.929C304.555 219.929 304.056 219.597 303.913 218.96L302.284 219.116C302.491 220.418 303.585 221.189 305.326 221.189C307.098 221.189 308.35 220.271 308.354 218.927C308.35 217.916 307.699 217.298 306.36 217.007L305.15 216.748C304.43 216.587 304.144 216.337 304.149 215.926C304.144 215.446 304.675 215.114 305.372 215.114C306.143 215.114 306.549 215.534 306.678 216L308.202 215.834Z",
  fill: "#212121"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 251.052,
  y: 157.051,
  width: 86,
  height: 14,
  rx: 2,
  fill: "white",
  stroke: "#212121",
  strokeWidth: 2
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 294,
  cy: 113,
  r: 24,
  fill: "#F3F0FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M275.579 128.373C278.589 121.138 285.726 116.051 294.052 116.051C302.377 116.051 309.515 121.138 312.525 128.373C308.123 133.675 301.482 137.051 294.052 137.051C286.622 137.051 279.981 133.675 275.579 128.373ZM302.104 106.051C302.104 110.469 298.522 114.051 294.104 114.051C289.685 114.051 286.104 110.469 286.104 106.051C286.104 101.633 289.685 98.0508 294.104 98.0508C298.522 98.0508 302.104 101.633 302.104 106.051Z",
  fill: "white"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 231.052,
  y: 70.0508,
  width: 126,
  height: 177,
  rx: 7,
  stroke: "#212121",
  strokeWidth: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M173 165V200C173 208.837 180.163 216 189 216H216",
  stroke: "#212121",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M210 209L217 216L210 223",
  stroke: "#212121",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M337 59L337 55C337 46.1634 329.837 39 321 39L278 39",
  stroke: "#212121",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M284 46L277 39L284 32",
  stroke: "#212121",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgAnchorBillingEmptyState;